
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// C:/DevOnFrameStudio/workspace/ecpl/ecpl-web-resources/node_modules/engine.io-client/index.js
// module id = 79
// module chunks = 0 1 2